export default __webpack_public_path__ + "static/schuermatt-879cc6dc49d792bc8ebf2931cd57169f.png";